
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon material-arrow_back","d":"M41.028 28.653H24.294l7.686-7.686-1.952-1.939-11 11 11 11 1.939-1.939-7.672-7.686h16.733zm43.944-.025H68.281l7.667-7.667L74 19.028 63.028 30 74 40.972l1.934-1.934-7.653-7.667h16.691z","fill":"currentColor"}})])
          )
        }
      }
    